/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core';
import { Keyboard } from '@tmna-ct/ipapps-core-js';
import styles from './styles';
import { keyboard } from '../../constants/index';

class KeyboardServices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keyboardWrapper: new Keyboard(),
      desireValue: '',
      setSelectedEvent: '',
      getSelectedEvent: '',
      getValue: '',
    };
  }

  componentDidMount() {
    const { keyboardWrapper } = this.state;
    keyboardWrapper.oninput = () => {
      console.log('Keyborad recieved input');
    };
    keyboardWrapper.onchange = () => {
      console.log('Keyborad change event');
    };
    keyboardWrapper.onfocus = () => {
      console.log('Keyborad focus event');
    };
    keyboardWrapper.onblur = () => {
      console.log('Keyborad lose focus');
    };
    keyboardWrapper.onclose = () => {
      console.log('Keyborad was closed');
    };
    keyboardWrapper.oncancel = () => {
      console.log('Keyborad closed/hidden');
    };
    keyboardWrapper.onerror = () => {
      console.log('Keyborad throw an error');
    };
  }

  getEvent() {
    const { keyboardWrapper, getSelectedEvent } = this.state;
    this.setState({
      getValue: keyboardWrapper.getProp(getSelectedEvent),
    });
  }

  setEvent() {
    const { keyboardWrapper, desireValue, setSelectedEvent } = this.state;
    keyboardWrapper.setProp(setSelectedEvent, desireValue);
  }

  render() {
    const {
      t,
      classes: {
        container,
        mainBody,
        mainActions,
        separation,
        bodySeparation,
        textArea,
        leftControl,
      },
    } = this.props;
    const { properties } = keyboard;
    const {
      keyboardWrapper,
      desireValue,
      setSelectedEvent,
      getSelectedEvent,
      getValue,
    } = this.state;
    return (
      <div className={container}>
        <h3 className={separation}>{t('screens.Keyboard.title')}</h3>
        <div className={mainActions}>
          <div className={bodySeparation}>
            <p>Keyboard Events and values</p>
            <ButtonGroup className={separation} size="small" color="primary">
              <Button onClick={() => keyboardWrapper.show()}>{t('screens.Keyboard.open')}</Button>
              <Button onClick={() => keyboardWrapper.close()}>{t('screens.Keyboard.close')}</Button>
            </ButtonGroup>
          </div>
        </div>
        <div className={mainBody}>
          <div className={bodySeparation}>
            <p>{t('screens.Keyboard.getDescription')}</p>
            <Select
              native
              value={getSelectedEvent}
              onChange={event => this.setState({ getSelectedEvent: event.target.value })}
              inputProps={{
                id: 'get-property-name',
              }}
            >
              <option value="" />
              {properties.map(event => (
                <option key={event} value={event}>
                  {event}
                </option>
              ))}
            </Select>
            <Button
              className={`${leftControl} ${separation}`}
              variant="contained"
              color="primary"
              onClick={() => this.getEvent()}
            >
              {t('screens.Keyboard.getProperty')}
            </Button>
            <TextField
              id="value-name"
              label="Keyboard Prop Value"
              disabled
              className={textArea}
              value={getValue}
              margin="normal"
            />
          </div>
          <div className={bodySeparation}>
            <p>{t('screens.Keyboard.setDescription')}</p>
            <Select
              native
              value={setSelectedEvent}
              onChange={event => this.setState({ setSelectedEvent: event.target.value })}
              inputProps={{
                id: 'set-property-name',
              }}
            >
              <option value="" />
              {properties.map(event => (
                <option key={event} value={event}>
                  {event}
                </option>
              ))}
            </Select>
            <Button
              className={`${leftControl} ${separation}`}
              variant="contained"
              color="primary"
              onClick={() => this.setEvent()}
            >
              {t('screens.Keyboard.setProperty')}
            </Button>
            <TextField
              id="standard-name"
              label="Keyboard Prop Value"
              className={textArea}
              value={desireValue}
              onChange={event => {
                this.setState({ desireValue: event.target.value });
              }}
              margin="normal"
            />
          </div>
        </div>
        <h3 className={separation}>{t('screens.Keyboard.title2')}</h3>
        <div className={mainBody}>
          <div className={bodySeparation}>
            <p>{t('screens.Keyboard.getDescription2')}</p>
          </div>
          <div className={bodySeparation}>
            <TextField
              label="Input type Text"
              margin="normal"
              className={textArea}
            />
            <TextField
              type="password"
              label="Input type Password"
              margin="normal"
              className={textArea}
            />
            <TextField
              type="email"
              label="Input type Email"
              margin="normal"
              className={textArea}
            />
          </div>
        </div>
      </div>
    );
  }
}

KeyboardServices.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(KeyboardServices));
